
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { getProxyType, getProStree } from '@/api/common/common'
import { getOrdinaryUserById, updateOrdinaryUser } from '@/api/agentcenter'
import util from '@/utils/busi/util'

@Component({
  name: 'grant-user-detail',
  components: {
    DictSelect
  }
})

export default class GrantUserDetail extends Vue {
  get isEdit () {
    return this.params.flag !== 'edit'
  }

  get settlementMethod () {
    return this.params.settlementMethod === 1 ? '电子结算' : this.params.settlementMethod === 2 ? '现金结算' : ''
  }

  get proType () {
    const temp: any[] = []
    this.params.lbUserProTypes && this.params.lbUserProTypes.map((v: any) => {
      temp.push(v.proTypeName)
    })
    return temp.join(',')
  }

  private presenterIdData: any[] = []

  private proTypeData: any[] = []

  private proTypeTemp:any = []

  private validatePhone (rule: any, value: any, callback: Function) {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (!reg.test(value)) {
      callback(new Error('请输入合法的联系电话'))
    } else {
      callback()
    }
  }

  private rules = {
    userAccount: [
      { required: true, message: '请输入登录账号', trigger: 'change' }
    ],
    userName: [
      { required: true, message: '请输入用户名称', trigger: 'change' }
    ],
    phone: [
      { validator: this.validatePhone, required: true, message: '请输入联系电话', trigger: 'change' }
    ],
    // wechat: [
    //   { required: true, message: '请输入微信号', trigger: 'change' }
    // ],
    proType: [
      { required: true, message: '请选择代理类型', trigger: 'change' }
    ],
    settlementMethod: [
      { required: true, message: '请输入结算方式', trigger: 'change' }
    ],
    deadline: [
      { required: true, message: '请选择日期', trigger: 'change' }
    ],
    state: [
      { required: true, message: '请选择是否启用', trigger: 'change' }
    ]
  }

  private onBack () {
    this.$router.push({
      name: 'customerCenter'
    })
  }

  private async onSave () {
    const params: any = util.trimForm({ ...this.params })
    const presenterId = params.presenterId ? params.presenterId.split(',') : null
    const proType = params.proType.split(',')
    const proTypes: any = []
    if (presenterId) {
      params.presenterId = presenterId[presenterId.length - 1].split('-')
    } else {
      params.presenterId = ['-1', '-1']
    }
    if (!params.proLevel) {
      params.proLevel = 1
    }
    proType.map((v: any) => {
      const item = v.split('-')
      if (item[1] && item[1] !== 'null' && item[1] !== 'undefined') {
        proTypes.push({
          userId: params.id,
          proType: item[0],
          businessId: item[1] || '1'
        })
      }
    })
    if (params.settlementMethod === 1 && (!params.payee || !params.openAccountBank || !params.openAccountAddress || !params.bankAccount)) {
      this.$message.error('收款人具体信息不能为空')
      return
    }
    await updateOrdinaryUser({
      presenter: params.presenterId[1],
      presenterId: params.presenterId[0],
      userName: params.userName,
      phone: params.phone,
      wechat: params.wechat,
      settlementMethod: params.settlementMethod,
      state: params.state,
      id: params.id,
      tbsUserId: params.tbsUserId,
      memo: params.memo,
      payee: params.payee,
      openAccountBank: params.openAccountBank,
      openAccountAddress: params.openAccountAddress,
      bankAccount: params.bankAccount,
      deadline: params.deadline * 1 + (24 * 60 * 60 * 1000 - 1),
      proLevel: params.proLevel,
      lbUserProTypes: proTypes,
      userAccount: params.userAccount,
      userType: 2 // params.userType
    }).then((res: any) => {
      if (res.code === 10000) {
        this.$message('该用户已成功升级为代理用户')
      }
    })
  }

  private params: any = util.getRouterParams()

  private elecBlock = {
    // eslint-disable-next-line eqeqeq
    hidden: this.params.settlementMethod == 1 ? !0 : !1,
    'elec-block': !0
  }

  @Watch('params.settlementMethod', { immediate: !0 })
  private settlementMethodChange (val: any) {
    if (val === 1) {
      this.elecBlock.hidden = !1
    } else {
      this.elecBlock.hidden = !0
    }
  }

  @Watch('params.proType', { deep: !0 })
  private proTypeChange (val: any) {
    this.proTypeTemp = val
    if (!val) return
    const dictionaryType: any = {}
    for (let i = 0; i < val.length; i++) {
      const value = val[i]
      const item = value.split('-')
      if (item[1] === 'null' || item[1] === 'undefine') {
        this.proTypeTemp.splice(i, 1);
        (this.$refs.proType as any).$refs.panel.clearCheckedNodes()
        this.params.proType = this.proTypeTemp
      } else if (dictionaryType[item[1]] > 0) {
        this.proTypeTemp.splice(i, 1);
        (this.$refs.proType as any).$refs.panel.clearCheckedNodes()
        this.params.proType = this.proTypeTemp
      }
      dictionaryType[item[1]] = 1
    }
  }

  private async initData () {
    await getProxyType({}).then((res: any) => {
      if (res.code === 10000) {
        this.proTypeData = this.formatProTypeData([res.object.rpcOptions])
      }
    })
    await getProStree({}).then((res: any) => {
      if (res.code === 10000) {
        this.presenterIdData = this.formatPresenterData(res.object)
      }
    })
    await getOrdinaryUserById({
      id: this.params.id
    }).then((res: any) => {
      if (res.code === 10000) {
        Object.keys(res.object).map((key: any) => {
          const val = res.object[key]
          if (val === -1 || val === '-1') this.params[key] = ''
          else this.params[key] = res.object[key]
        })
      }
    })
    this.params.proLevel = 2
    this.params.presenterId = this.presenterIdData[0].id
    this.params.settlementMethod = 2
    this.params.deadline = (new Date()).getTime() + (365 * 24 * 60 * 60 * 1000)
  }

  private formatPresenterData (list: any) {
    if (!list || list.length === 0) return []
    for (let i = 0; i < list.length; i++) {
      list[i].id = list[i].id + '-' + list[i].userName
      if (list[i].chirld) {
        list[i].chirld = list[i].chirld.length === 0 ? null : this.formatPresenterData(list[i].chirld)
      }
    }
    return list
  }

  private formatProTypeData (list: any) {
    if (!list || list.length === 0) return []
    for (let i = 0; i < list.length; i++) {
      list[i].optionKey = list[i].optionKey + '-' + list[i].businessId
      if (list[i].children) {
        list[i].children = list[i].children.length === 0 ? null : this.formatProTypeData(list[i].children)
      }
    }
    return list
  }

  private presenterIdChange (val: any) {
    this.params.proLevel = val.length + 1
  }

  private proLevelChange (val: any) {
    if (this.params.presenterId && val <= this.params.presenterId.length) {
      this.params.presenterId = []
    }
  }

  private validate () {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        this.onSave()
      } else {
        this.$message.error('请正确填写数据')
        return false
      }
    })
  }

  beforeMount () {
    this.params = util.getRouterParams()
    this.initData()
  }
}
